/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Publizon Library API
 * Pubhub exists in two separate environments, each with their own server, code and database. Please use the web service located at library-api.qa.pubhub.dk when developing and testing.
 * Orders/loans created in test environment will not be invoiced. Please request a new license key for the production environment when you're ready to go live.
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from "@tanstack/react-query";

import type {
  ApiResult,
  ChecklistResult,
  CreateLoanResult,
  FriendlyCardResult,
  GetV1UserLoansParams,
  LibraryProfile,
  LoanListResult,
  LoanResult,
  LoanStatusListResult,
  LoanStatusResult,
  PostV1UserLoansIdentifierParams,
  ProductListResult,
  ProductResult,
  ReservationInput,
  ReservationListResult
} from "./model";

import { mutator } from "./mutator/mutator";
import type { ErrorType, BodyType } from "./mutator/mutator";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getGetV1UserCardnumberFriendlyUrl = () => {
  return `/v1/user/cardnumber/friendly`;
};

/**
 * Sample **request**:
 *
 *     GET /friendly
 *     {
 *         "name": "Some name"
 *     }
 * @summary Gets the user's friendly card number.
 */
export const getV1UserCardnumberFriendly = async (
  options?: Parameters<typeof mutator>[1]
): Promise<FriendlyCardResult[]> => {
  return mutator<FriendlyCardResult[]>(getGetV1UserCardnumberFriendlyUrl(), {
    ...options,
    method: "GET"
  });
};

export const getGetV1UserCardnumberFriendlyQueryKey = () => {
  return [`/v1/user/cardnumber/friendly`] as const;
};

export const getGetV1UserCardnumberFriendlyQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
  TError = ErrorType<ApiResult>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1UserCardnumberFriendlyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>
  > = ({ signal }) =>
    getV1UserCardnumberFriendly({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1UserCardnumberFriendlyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>
>;
export type GetV1UserCardnumberFriendlyQueryError = ErrorType<ApiResult>;

export function useGetV1UserCardnumberFriendly<
  TData = Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
  TError = ErrorType<ApiResult>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
          TError,
          Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserCardnumberFriendly<
  TData = Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
  TError = ErrorType<ApiResult>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
          TError,
          Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserCardnumberFriendly<
  TData = Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
  TError = ErrorType<ApiResult>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets the user's friendly card number.
 */

export function useGetV1UserCardnumberFriendly<
  TData = Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
  TError = ErrorType<ApiResult>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1UserCardnumberFriendlyQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetV1UserChecklistUrl = () => {
  return `/v1/user/checklist`;
};

/**
 * @summary List all checklist items of the user.
 */
export const getV1UserChecklist = async (
  options?: Parameters<typeof mutator>[1]
): Promise<ChecklistResult> => {
  return mutator<ChecklistResult>(getGetV1UserChecklistUrl(), {
    ...options,
    method: "GET"
  });
};

export const getGetV1UserChecklistQueryKey = () => {
  return [`/v1/user/checklist`] as const;
};

export const getGetV1UserChecklistQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserChecklist>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1UserChecklist>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1UserChecklistQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1UserChecklist>>
  > = ({ signal }) => getV1UserChecklist({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserChecklist>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1UserChecklistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserChecklist>>
>;
export type GetV1UserChecklistQueryError = ErrorType<unknown>;

export function useGetV1UserChecklist<
  TData = Awaited<ReturnType<typeof getV1UserChecklist>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserChecklist>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserChecklist>>,
          TError,
          Awaited<ReturnType<typeof getV1UserChecklist>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserChecklist<
  TData = Awaited<ReturnType<typeof getV1UserChecklist>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserChecklist>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserChecklist>>,
          TError,
          Awaited<ReturnType<typeof getV1UserChecklist>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserChecklist<
  TData = Awaited<ReturnType<typeof getV1UserChecklist>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserChecklist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all checklist items of the user.
 */

export function useGetV1UserChecklist<
  TData = Awaited<ReturnType<typeof getV1UserChecklist>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserChecklist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1UserChecklistQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPostV1UserChecklistIdentifierUrl = (identifier: string) => {
  return `/v1/user/checklist/${identifier}`;
};

/**
 * @summary Add a book to the user's checklist.
 */
export const postV1UserChecklistIdentifier = async (
  identifier: string,
  options?: Parameters<typeof mutator>[1]
): Promise<ApiResult> => {
  return mutator<ApiResult>(getPostV1UserChecklistIdentifierUrl(identifier), {
    ...options,
    method: "POST"
  });
};

export const getPostV1UserChecklistIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>,
    TError,
    { identifier: string },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  const mutationKey = ["postV1UserChecklistIdentifier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>,
    { identifier: string }
  > = (props) => {
    const { identifier } = props ?? {};

    return postV1UserChecklistIdentifier(identifier, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1UserChecklistIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>
>;

export type PostV1UserChecklistIdentifierMutationError = ErrorType<unknown>;

/**
 * @summary Add a book to the user's checklist.
 */
export const usePostV1UserChecklistIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>,
      TError,
      { identifier: string },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  return useMutation(
    getPostV1UserChecklistIdentifierMutationOptions(options),
    queryClient
  );
};

export const getDeleteV1UserChecklistIdentifierUrl = (identifier: string) => {
  return `/v1/user/checklist/${identifier}`;
};

/**
 * @summary Delete a book from the user's checklist.
 */
export const deleteV1UserChecklistIdentifier = async (
  identifier: string,
  options?: Parameters<typeof mutator>[1]
): Promise<ApiResult> => {
  return mutator<ApiResult>(getDeleteV1UserChecklistIdentifierUrl(identifier), {
    ...options,
    method: "DELETE"
  });
};

export const getDeleteV1UserChecklistIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>,
    TError,
    { identifier: string },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  const mutationKey = ["deleteV1UserChecklistIdentifier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>,
    { identifier: string }
  > = (props) => {
    const { identifier } = props ?? {};

    return deleteV1UserChecklistIdentifier(identifier, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV1UserChecklistIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>
>;

export type DeleteV1UserChecklistIdentifierMutationError = ErrorType<unknown>;

/**
 * @summary Delete a book from the user's checklist.
 */
export const useDeleteV1UserChecklistIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>,
      TError,
      { identifier: string },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  return useMutation(
    getDeleteV1UserChecklistIdentifierMutationOptions(options),
    queryClient
  );
};

export const getGetV1LibraryProfileUrl = () => {
  return `/v1/library/profile`;
};

export const getV1LibraryProfile = async (
  options?: Parameters<typeof mutator>[1]
): Promise<LibraryProfile> => {
  return mutator<LibraryProfile>(getGetV1LibraryProfileUrl(), {
    ...options,
    method: "GET"
  });
};

export const getGetV1LibraryProfileQueryKey = () => {
  return [`/v1/library/profile`] as const;
};

export const getGetV1LibraryProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1LibraryProfile>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1LibraryProfile>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1LibraryProfileQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1LibraryProfile>>
  > = ({ signal }) => getV1LibraryProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1LibraryProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1LibraryProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1LibraryProfile>>
>;
export type GetV1LibraryProfileQueryError = ErrorType<unknown>;

export function useGetV1LibraryProfile<
  TData = Awaited<ReturnType<typeof getV1LibraryProfile>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1LibraryProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1LibraryProfile>>,
          TError,
          Awaited<ReturnType<typeof getV1LibraryProfile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1LibraryProfile<
  TData = Awaited<ReturnType<typeof getV1LibraryProfile>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1LibraryProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1LibraryProfile>>,
          TError,
          Awaited<ReturnType<typeof getV1LibraryProfile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1LibraryProfile<
  TData = Awaited<ReturnType<typeof getV1LibraryProfile>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1LibraryProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetV1LibraryProfile<
  TData = Awaited<ReturnType<typeof getV1LibraryProfile>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1LibraryProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1LibraryProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetV1UserLoansUrl = (params?: GetV1UserLoansParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/v1/user/loans?${stringifiedParams}`
    : `/v1/user/loans`;
};

/**
 * @summary Lists all active loans of the user.
 */
export const getV1UserLoans = async (
  params?: GetV1UserLoansParams,
  options?: Parameters<typeof mutator>[1]
): Promise<LoanListResult> => {
  return mutator<LoanListResult>(getGetV1UserLoansUrl(params), {
    ...options,
    method: "GET"
  });
};

export const getGetV1UserLoansQueryKey = (params?: GetV1UserLoansParams) => {
  return [`/v1/user/loans`, ...(params ? [params] : [])] as const;
};

export const getGetV1UserLoansQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserLoans>>,
  TError = ErrorType<unknown>
>(
  params?: GetV1UserLoansParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1UserLoans>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1UserLoansQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1UserLoans>>> = ({
    signal
  }) => getV1UserLoans(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserLoans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1UserLoansQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserLoans>>
>;
export type GetV1UserLoansQueryError = ErrorType<unknown>;

export function useGetV1UserLoans<
  TData = Awaited<ReturnType<typeof getV1UserLoans>>,
  TError = ErrorType<unknown>
>(
  params: undefined | GetV1UserLoansParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1UserLoans>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserLoans>>,
          TError,
          Awaited<ReturnType<typeof getV1UserLoans>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserLoans<
  TData = Awaited<ReturnType<typeof getV1UserLoans>>,
  TError = ErrorType<unknown>
>(
  params?: GetV1UserLoansParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1UserLoans>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserLoans>>,
          TError,
          Awaited<ReturnType<typeof getV1UserLoans>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserLoans<
  TData = Awaited<ReturnType<typeof getV1UserLoans>>,
  TError = ErrorType<unknown>
>(
  params?: GetV1UserLoansParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1UserLoans>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all active loans of the user.
 */

export function useGetV1UserLoans<
  TData = Awaited<ReturnType<typeof getV1UserLoans>>,
  TError = ErrorType<unknown>
>(
  params?: GetV1UserLoansParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1UserLoans>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1UserLoansQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetV1UserLoansIdentifierUrl = (identifier: string) => {
  return `/v1/user/loans/${identifier}`;
};

/**
 * @summary Gets details of a specific loan.
 */
export const getV1UserLoansIdentifier = async (
  identifier: string,
  options?: Parameters<typeof mutator>[1]
): Promise<LoanResult> => {
  return mutator<LoanResult>(getGetV1UserLoansIdentifierUrl(identifier), {
    ...options,
    method: "GET"
  });
};

export const getGetV1UserLoansIdentifierQueryKey = (identifier: string) => {
  return [`/v1/user/loans/${identifier}`] as const;
};

export const getGetV1UserLoansIdentifierQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1UserLoansIdentifierQueryKey(identifier);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1UserLoansIdentifier>>
  > = ({ signal }) =>
    getV1UserLoansIdentifier(identifier, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: identifier !== null && identifier !== undefined,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1UserLoansIdentifierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserLoansIdentifier>>
>;
export type GetV1UserLoansIdentifierQueryError = ErrorType<unknown>;

export function useGetV1UserLoansIdentifier<
  TData = Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
          TError,
          Awaited<ReturnType<typeof getV1UserLoansIdentifier>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserLoansIdentifier<
  TData = Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
          TError,
          Awaited<ReturnType<typeof getV1UserLoansIdentifier>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserLoansIdentifier<
  TData = Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets details of a specific loan.
 */

export function useGetV1UserLoansIdentifier<
  TData = Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1UserLoansIdentifierQueryOptions(
    identifier,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPostV1UserLoansIdentifierUrl = (
  identifier: string,
  params?: PostV1UserLoansIdentifierParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/v1/user/loans/${identifier}?${stringifiedParams}`
    : `/v1/user/loans/${identifier}`;
};

/**
 * @summary Creates a new loan.
 */
export const postV1UserLoansIdentifier = async (
  identifier: string,
  params?: PostV1UserLoansIdentifierParams,
  options?: Parameters<typeof mutator>[1]
): Promise<CreateLoanResult> => {
  return mutator<CreateLoanResult>(
    getPostV1UserLoansIdentifierUrl(identifier, params),
    {
      ...options,
      method: "POST"
    }
  );
};

export const getPostV1UserLoansIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UserLoansIdentifier>>,
    TError,
    { identifier: string; params?: PostV1UserLoansIdentifierParams },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1UserLoansIdentifier>>,
  TError,
  { identifier: string; params?: PostV1UserLoansIdentifierParams },
  TContext
> => {
  const mutationKey = ["postV1UserLoansIdentifier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1UserLoansIdentifier>>,
    { identifier: string; params?: PostV1UserLoansIdentifierParams }
  > = (props) => {
    const { identifier, params } = props ?? {};

    return postV1UserLoansIdentifier(identifier, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1UserLoansIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1UserLoansIdentifier>>
>;

export type PostV1UserLoansIdentifierMutationError = ErrorType<unknown>;

/**
 * @summary Creates a new loan.
 */
export const usePostV1UserLoansIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1UserLoansIdentifier>>,
      TError,
      { identifier: string; params?: PostV1UserLoansIdentifierParams },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postV1UserLoansIdentifier>>,
  TError,
  { identifier: string; params?: PostV1UserLoansIdentifierParams },
  TContext
> => {
  return useMutation(
    getPostV1UserLoansIdentifierMutationOptions(options),
    queryClient
  );
};

export const getGetV1LoanstatusIdentifierUrl = (identifier: string) => {
  return `/v1/loanstatus/${identifier}`;
};

/**
 * @summary Get loan status of a specific product.
 */
export const getV1LoanstatusIdentifier = async (
  identifier: string,
  options?: Parameters<typeof mutator>[1]
): Promise<LoanStatusResult> => {
  return mutator<LoanStatusResult>(
    getGetV1LoanstatusIdentifierUrl(identifier),
    {
      ...options,
      method: "GET"
    }
  );
};

export const getGetV1LoanstatusIdentifierQueryKey = (identifier: string) => {
  return [`/v1/loanstatus/${identifier}`] as const;
};

export const getGetV1LoanstatusIdentifierQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1LoanstatusIdentifierQueryKey(identifier);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>
  > = ({ signal }) =>
    getV1LoanstatusIdentifier(identifier, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: identifier !== null && identifier !== undefined,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1LoanstatusIdentifierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>
>;
export type GetV1LoanstatusIdentifierQueryError = ErrorType<unknown>;

export function useGetV1LoanstatusIdentifier<
  TData = Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
          TError,
          Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1LoanstatusIdentifier<
  TData = Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
          TError,
          Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1LoanstatusIdentifier<
  TData = Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get loan status of a specific product.
 */

export function useGetV1LoanstatusIdentifier<
  TData = Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1LoanstatusIdentifierQueryOptions(
    identifier,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPostV1LoanstatusUrl = () => {
  return `/v1/loanstatus`;
};

/**
 * @summary Get loan status of all products.
 */
export const postV1Loanstatus = async (
  postV1LoanstatusBody?: string[],
  options?: Parameters<typeof mutator>[1]
): Promise<LoanStatusListResult> => {
  return mutator<LoanStatusListResult>(getPostV1LoanstatusUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(postV1LoanstatusBody)
  });
};

export const getPostV1LoanstatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1Loanstatus>>,
    TError,
    { data?: BodyType<string[]> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1Loanstatus>>,
  TError,
  { data?: BodyType<string[]> },
  TContext
> => {
  const mutationKey = ["postV1Loanstatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1Loanstatus>>,
    { data?: BodyType<string[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV1Loanstatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1LoanstatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1Loanstatus>>
>;
export type PostV1LoanstatusMutationBody = BodyType<string[]> | undefined;
export type PostV1LoanstatusMutationError = ErrorType<unknown>;

/**
 * @summary Get loan status of all products.
 */
export const usePostV1Loanstatus = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1Loanstatus>>,
      TError,
      { data?: BodyType<string[]> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postV1Loanstatus>>,
  TError,
  { data?: BodyType<string[]> },
  TContext
> => {
  return useMutation(getPostV1LoanstatusMutationOptions(options), queryClient);
};

export const getGetV1ProductsIdentifierUrl = (identifier: string) => {
  return `/v1/products/${identifier}`;
};

/**
 * @summary Get a specific product.
 */
export const getV1ProductsIdentifier = async (
  identifier: string,
  options?: Parameters<typeof mutator>[1]
): Promise<ProductResult> => {
  return mutator<ProductResult>(getGetV1ProductsIdentifierUrl(identifier), {
    ...options,
    method: "GET"
  });
};

export const getGetV1ProductsIdentifierQueryKey = (identifier: string) => {
  return [`/v1/products/${identifier}`] as const;
};

export const getGetV1ProductsIdentifierQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1ProductsIdentifierQueryKey(identifier);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ProductsIdentifier>>
  > = ({ signal }) =>
    getV1ProductsIdentifier(identifier, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: identifier !== null && identifier !== undefined,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ProductsIdentifierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ProductsIdentifier>>
>;
export type GetV1ProductsIdentifierQueryError = ErrorType<unknown>;

export function useGetV1ProductsIdentifier<
  TData = Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
          TError,
          Awaited<ReturnType<typeof getV1ProductsIdentifier>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ProductsIdentifier<
  TData = Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
          TError,
          Awaited<ReturnType<typeof getV1ProductsIdentifier>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ProductsIdentifier<
  TData = Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a specific product.
 */

export function useGetV1ProductsIdentifier<
  TData = Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ProductsIdentifierQueryOptions(
    identifier,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetV1ProductsUrl = () => {
  return `/v1/products`;
};

/**
 * @summary List all products.
 */
export const getV1Products = async (
  options?: Parameters<typeof mutator>[1]
): Promise<ProductListResult> => {
  return mutator<ProductListResult>(getGetV1ProductsUrl(), {
    ...options,
    method: "GET"
  });
};

export const getGetV1ProductsQueryKey = () => {
  return [`/v1/products`] as const;
};

export const getGetV1ProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1Products>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV1Products>>, TError, TData>
  >;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1ProductsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1Products>>> = ({
    signal
  }) => getV1Products({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1Products>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1Products>>
>;
export type GetV1ProductsQueryError = ErrorType<unknown>;

export function useGetV1Products<
  TData = Awaited<ReturnType<typeof getV1Products>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1Products>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1Products>>,
          TError,
          Awaited<ReturnType<typeof getV1Products>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1Products<
  TData = Awaited<ReturnType<typeof getV1Products>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1Products>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1Products>>,
          TError,
          Awaited<ReturnType<typeof getV1Products>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1Products<
  TData = Awaited<ReturnType<typeof getV1Products>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1Products>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all products.
 */

export function useGetV1Products<
  TData = Awaited<ReturnType<typeof getV1Products>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1Products>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ProductsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetV1UserReservationsUrl = () => {
  return `/v1/user/reservations`;
};

/**
 * @summary Lists all reservations of the user.
 */
export const getV1UserReservations = async (
  options?: Parameters<typeof mutator>[1]
): Promise<ReservationListResult> => {
  return mutator<ReservationListResult>(getGetV1UserReservationsUrl(), {
    ...options,
    method: "GET"
  });
};

export const getGetV1UserReservationsQueryKey = () => {
  return [`/v1/user/reservations`] as const;
};

export const getGetV1UserReservationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserReservations>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1UserReservations>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1UserReservationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1UserReservations>>
  > = ({ signal }) => getV1UserReservations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserReservations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1UserReservationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserReservations>>
>;
export type GetV1UserReservationsQueryError = ErrorType<unknown>;

export function useGetV1UserReservations<
  TData = Awaited<ReturnType<typeof getV1UserReservations>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserReservations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserReservations>>,
          TError,
          Awaited<ReturnType<typeof getV1UserReservations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserReservations<
  TData = Awaited<ReturnType<typeof getV1UserReservations>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserReservations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserReservations>>,
          TError,
          Awaited<ReturnType<typeof getV1UserReservations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserReservations<
  TData = Awaited<ReturnType<typeof getV1UserReservations>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserReservations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all reservations of the user.
 */

export function useGetV1UserReservations<
  TData = Awaited<ReturnType<typeof getV1UserReservations>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserReservations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1UserReservationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPostV1UserReservationsIdentifierUrl = (identifier: string) => {
  return `/v1/user/reservations/${identifier}`;
};

/**
 * @summary Creates a new reservation.
 */
export const postV1UserReservationsIdentifier = async (
  identifier: string,
  reservationInput?: ReservationInput,
  options?: Parameters<typeof mutator>[1]
): Promise<ApiResult> => {
  return mutator<ApiResult>(
    getPostV1UserReservationsIdentifierUrl(identifier),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(reservationInput)
    }
  );
};

export const getPostV1UserReservationsIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>,
    TError,
    { identifier: string; data?: BodyType<ReservationInput> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>,
  TError,
  { identifier: string; data?: BodyType<ReservationInput> },
  TContext
> => {
  const mutationKey = ["postV1UserReservationsIdentifier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>,
    { identifier: string; data?: BodyType<ReservationInput> }
  > = (props) => {
    const { identifier, data } = props ?? {};

    return postV1UserReservationsIdentifier(identifier, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1UserReservationsIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>
>;
export type PostV1UserReservationsIdentifierMutationBody =
  BodyType<ReservationInput> | undefined;
export type PostV1UserReservationsIdentifierMutationError = ErrorType<unknown>;

/**
 * @summary Creates a new reservation.
 */
export const usePostV1UserReservationsIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>,
      TError,
      { identifier: string; data?: BodyType<ReservationInput> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>,
  TError,
  { identifier: string; data?: BodyType<ReservationInput> },
  TContext
> => {
  return useMutation(
    getPostV1UserReservationsIdentifierMutationOptions(options),
    queryClient
  );
};

export const getPatchV1UserReservationsIdentifierUrl = (identifier: string) => {
  return `/v1/user/reservations/${identifier}`;
};

/**
 * @summary Updates the phone number and email address of a specific reservation.
 */
export const patchV1UserReservationsIdentifier = async (
  identifier: string,
  reservationInput?: ReservationInput,
  options?: Parameters<typeof mutator>[1]
): Promise<ApiResult> => {
  return mutator<ApiResult>(
    getPatchV1UserReservationsIdentifierUrl(identifier),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(reservationInput)
    }
  );
};

export const getPatchV1UserReservationsIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>,
    TError,
    { identifier: string; data?: BodyType<ReservationInput> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>,
  TError,
  { identifier: string; data?: BodyType<ReservationInput> },
  TContext
> => {
  const mutationKey = ["patchV1UserReservationsIdentifier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>,
    { identifier: string; data?: BodyType<ReservationInput> }
  > = (props) => {
    const { identifier, data } = props ?? {};

    return patchV1UserReservationsIdentifier(identifier, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV1UserReservationsIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>
>;
export type PatchV1UserReservationsIdentifierMutationBody =
  BodyType<ReservationInput> | undefined;
export type PatchV1UserReservationsIdentifierMutationError = ErrorType<unknown>;

/**
 * @summary Updates the phone number and email address of a specific reservation.
 */
export const usePatchV1UserReservationsIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>,
      TError,
      { identifier: string; data?: BodyType<ReservationInput> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>,
  TError,
  { identifier: string; data?: BodyType<ReservationInput> },
  TContext
> => {
  return useMutation(
    getPatchV1UserReservationsIdentifierMutationOptions(options),
    queryClient
  );
};

export const getDeleteV1UserReservationsIdentifierUrl = (
  identifier: string
) => {
  return `/v1/user/reservations/${identifier}`;
};

/**
 * @summary Cancels a reservation.
 */
export const deleteV1UserReservationsIdentifier = async (
  identifier: string,
  options?: Parameters<typeof mutator>[1]
): Promise<ApiResult> => {
  return mutator<ApiResult>(
    getDeleteV1UserReservationsIdentifierUrl(identifier),
    {
      ...options,
      method: "DELETE"
    }
  );
};

export const getDeleteV1UserReservationsIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>,
    TError,
    { identifier: string },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  const mutationKey = ["deleteV1UserReservationsIdentifier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>,
    { identifier: string }
  > = (props) => {
    const { identifier } = props ?? {};

    return deleteV1UserReservationsIdentifier(identifier, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV1UserReservationsIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>
>;

export type DeleteV1UserReservationsIdentifierMutationError =
  ErrorType<unknown>;

/**
 * @summary Cancels a reservation.
 */
export const useDeleteV1UserReservationsIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>,
      TError,
      { identifier: string },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  return useMutation(
    getDeleteV1UserReservationsIdentifierMutationOptions(options),
    queryClient
  );
};
